'use strict';
let base = require('./base');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
  $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements,
    },

    klarna_message: () => {
        $('body').on('quantity:updated', function () {
            console.log("UPDATED QUANTITY FOR KLARNA")
            KlarnaUpdate()
        });
        $('body').on('product:afterAttributeSelect', function () {
            console.log("UPDATED KLARNA")
            KlarnaUpdate()
        })

        function KlarnaUpdate() {
            var badgeEl = $('klarna-placement[data-key="credit-promotion-badge"]');
            var newPrice = badgeEl.data('original-price') * Number($('.quantity-select').val());
            badgeEl.attr('data-purchase-amount', newPrice);
            window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        }
    },

  availability: base.availability,

  size: base.selectAttribute,

  color: base.colorAttribute,

  addToCart: base.addToCart,

  addToWishlist: base.addToWishlist,

  updateAttributesAndDetails: function () {
    $('body').on('product:statusUpdate', function (e, data) {
      let $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

      $productContainer.find('.description-and-detail .product-attributes').empty().html(data.attributesHtml);

      if (data.shortDescription) {
        $productContainer.find('.description-and-detail .description').removeClass('hidden-xl-down');
        $productContainer.find('.description-and-detail .description .content').empty().html(data.shortDescription);
      } else {
        $productContainer.find('.description-and-detail .description').addClass('hidden-xl-down');
      }

      if (data.longDescription) {
        $productContainer.find('.description-and-detail .details').removeClass('hidden-xl-down');
        $productContainer.find('.description-and-detail .details .content').empty().html(data.longDescription);
      } else {
        $productContainer.find('.description-and-detail .details').addClass('hidden-xl-down');
      }
    });
  },

  showSpinner: function () {
    $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
      window.$.spinner().start();
    });
  },
  updateAttribute: function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
      if ($('.product-detail>.bundle-items').length) {
        response.container.attr('data-pid', response.data.product.id);
        response.container.find('.product-id').text(response.data.product.id);
      } else if ($('.product-set-detail').eq(0)) {
        response.container.attr('data-pid', response.data.product.id);
        response.container.find('.product-id').text(response.data.product.id);
      } else {
        $('.product-id').text(response.data.product.id);
        $('.product-detail:not(".bundle-item")').attr('data-pid', response.data.product.id);
      }

      $('button.add-to-cart').attr('data-pid', response.data.product.id);
      $('button.add-to-wish-list').attr('data-pid', response.data.product.id);
    });
  },
  updateAddToWishlist: function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
      // update local add to cart (for sets)
      const $wishlistButton = $('button.js-add-to-wishlist');
      if (response.data.product.inWishlist) {
        $wishlistButton.addClass('is-full');
        $wishlistButton.val($wishlistButton.data('wishlist-remove'));
      } else {
        $wishlistButton.removeClass('is-full');
        $wishlistButton.val($wishlistButton.data('wishlist-add'));
      }
    });
  },
  updateAddToCart: function () {
    $('body').on('product:updateAddToCart', function (e, response) {
      // update local add to cart (for sets)
      $('button.add-to-cart', response.$productContainer).attr('disabled', !response.product.readyToOrder || !response.product.available);
      $('button.js-add-to-wishlist', response.$productContainer).attr('disabled', !response.product.readyToOrder || !response.product.available);

      let enable = $('.product-availability')
        .toArray()
        .every(function (item) {
          return $(item).data('available') && $(item).data('ready-to-order');
        });
      module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
    });
  },
  updateAvailability: function () {
    $('body').on('product:updateAvailability', function (e, response) {
      $('div.availability', response.$productContainer).data('ready-to-order', response.product.readyToOrder).data('available', response.product.available);

      $('.availability-msg', response.$productContainer).empty().html(response.message);

      $('.quantity-select', response.$productContainer).val(1);
      $('.quantity-select', response.$productContainer).attr(
        'data-maxqty',
        response.product.isMarketplaceProduct && response.miraklOffer && response.miraklOffer.stockAvailability
          ? response.miraklOffer.stockAvailability.toFixed()
          : response.product.ats
      );

      if ($('.global-availability').length) {
        let allAvailable = $('.product-availability')
          .toArray()
          .every(function (item) {
            return $(item).data('available');
          });

        let allReady = $('.product-availability')
          .toArray()
          .every(function (item) {
            return $(item).data('ready-to-order');
          });

        $('.global-availability').data('ready-to-order', allReady).data('available', allAvailable);

        $('.global-availability .availability-msg')
          .empty()
          .html(allReady ? response.message : response.resources.info_selectforstock);
      }
    });
  },
  sizeChart: function () {
    $('.size-chart a').on('click', function (e) {
      e.preventDefault();
      let url = $(this).attr('href');
      let $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
      if ($prodSizeChart.is(':empty')) {
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          success: function (data) {
            $prodSizeChart.append(data.content);
          },
        });
      }
      $prodSizeChart.toggleClass('active');
    });

    let $sizeChart = $('.size-chart-collapsible');
    $('body').on('click touchstart', function (e) {
      if ($('.size-chart').has(e.target).length <= 0) {
        $sizeChart.removeClass('active');
      }
    });
  },
  copyProductLink: function () {
    $('body').on('click', '#fa-link', function () {
      event.preventDefault();
      let $temp = $('<input>');
      $('body').append($temp);
      $temp.val($('#shareUrl').val()).select();
      document.execCommand('copy');
      $temp.remove();
      $('.copy-link-message').attr('role', 'alert');
      $('.copy-link-message').removeClass('d-none');
      setTimeout(function () {
        $('.copy-link-message').addClass('d-none');
      }, 3000);
    });
  },

  focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
};
